<template>
    <div class="modal" :class="{ 'is-active': opened }">
        <div class="modal-background" @click="goHome"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ $t("join-room.room-id") }}</p>
                <button class="delete" @click="goHome"></button>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <div class="control">
                        <input
                            ref="inputRoomId"
                            type="text"
                            class="input"
                            :placeholder="$t('join-room.room-id-placeholder')"
                            v-model="roomId"
                            @keyup.enter="joinRoom"
                        />
                    </div>
                    <p v-if="haveError" class="help is-danger">{{ error }}</p>
                </div>
            </section>
            <footer class="modal-card-foot flex-end">
                <button
                    class="button is-success"
                    :class="{ 'is-loading': isLoading }"
                    @click="joinRoom"
                    :disabled="isEmptyRoomId"
                >
                    {{ $t("join-room.join") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";

export default {
    name: "join-room-modal",
    props: {
        display: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            roomId: "",
            opened: false,

            isLoading: false,
            error: "",
        };
    },
    mounted() {
        this.opened = this.display;
        this.$nextTick(() => this.$refs.inputRoomId.focus());
    },
    watch: {
        display(opened) {
            this.opened = opened;
        },
    },
    computed: {
        isEmptyRoomId() {
            return (
                this.roomId === "" ||
                this.roomId === null ||
                this.roomId === undefined
            );
        },
        haveError() {
            return this.error !== "";
        },
    },
    methods: {
        async joinRoom() {
            this.isLoading = true;
            if (!this.isEmptyRoomId) {
                try {
                    var response = await RepositoryFactory.conference.get({
                        roomId: this.roomId,
                    });
                    this.$router.push({
                        name: "room",
                        params: { roomId: response.data.id },
                    });
                } catch (error) {
                    window.console.log(error);
                    this.error = "Not exist a room with that id";
                }
            }
            this.isLoading = false;
        },
        goHome() {
            this.$router.push({ name: "home" });
        },
    },
};
</script>
